// Recipient counts for the message automation preview. The numbers come from
// automations/recipient_counts, which resolves them the same way the send does.

const plural = (count, word) => `${count.toLocaleString()} ${word}${count === 1 ? '' : 's'}`

export function recipientCountsEndpoint(audiences, segment) {
  const ids = audiences.map(audience => audience.id).join(',')
  return `automations/recipient_counts?audience_ids=${ids}&audience_list=${segment}`
}

// One row per selected list. count is null until the counts have loaded.
export function listRecipientRows(audiences, counts) {
  return audiences.map(audience => {
    const found = counts?.audiences.find(x => String(x.audience_id) === String(audience.id))
    return {
      id: audience.id,
      name: audience.attributes.audience_name,
      count: found ? plural(found.count, 'customer') : null
    }
  })
}

// How many messages go out: a customer on two lists gets one message, and
// customers who opted out or have no phone number are not texted.
export function recipientSummary(counts) {
  if (!counts) return null
  const { total, reachable_by_sms: reachable } = counts
  const skipped = total - reachable
  if (!skipped) return `${plural(total, 'message')} will be sent.`
  return `${plural(reachable, 'message')} will be sent. ${plural(skipped, 'customer')} will not be texted (opted out or no phone number).`
}
